import React, {useState, useEffect, useRef} from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Inputs
import { TextInputField, Button, DropDownField, MultiSelectField, AutoCompleteField } from '../helpers';

// utils
import { gstCalculation, round, validateInputs } from '../utils';

// constants
import { DECIMAL_LIMIT } from '../constants';

// components
import Loading from './Loading';

// validation
import { ReplacementItemValidationSchema, replacementItemInitialState } from '../validation/replacementItemValidation';

// Redux
import { fetchHSNMasterData, fetchMaterialUoms } from '../services/redux/reducers/commonThunk';
import { raiseToast } from '../services/redux/reducers/toast/toast';
import { getPMCompanyConfig } from '../setup/pmCompanyConfig';



const ReplacementItems = (props) => {

    const dispatch = useDispatch()

    const { selectedReplaceBuyerReqItems } = props

    const [replaceItem, setReplaceItem] = useState({...replacementItemInitialState})
    const [GSTRates, setGSTRates] = useState([])
    const [formErrors, setFormErrors] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [searchedmaterialUOMs, setSearchedmaterialUOMs] = useState([])


    const userDetails = useSelector(state => state.userDetails)
    const HSNMasterData = useSelector((state) => state.common.HSNMaster)
    const materialUOMData = useSelector(state => state.common.materialUOMs)

    const pmCompanyDetails = useSelector((state) => state.userDetails.PMCompanyDetails)
    const pmCompanyConfig = getPMCompanyConfig(pmCompanyDetails.companyId)

    useEffect(()=>{
        dispatch(fetchHSNMasterData())
        dispatch(fetchMaterialUoms())
    }, [])

    useEffect(() => {
        
        if (props.selectedReplaceBuyerReqItems) {
            let maxGSTRate = 0
            let totalAmount = 0
            props.selectedReplaceBuyerReqItems.map(eachBuyerReqItem => {
                totalAmount += eachBuyerReqItem.qty * eachBuyerReqItem.unitPrice
                if(eachBuyerReqItem.GSTRate > maxGSTRate){
                    maxGSTRate = eachBuyerReqItem.GSTRate
                }
            })

            replaceItem['totalAmount'] = round(totalAmount, DECIMAL_LIMIT)
            replaceItem['totalAmountWithTax'] = round(totalAmount+((maxGSTRate/100)*totalAmount), DECIMAL_LIMIT)
            replaceItem['GSTRate'] = maxGSTRate 

            setReplaceItem({...replaceItem})
        }
    }, [props.selectedReplaceBuyerReqItems])

    /*
    const onBlurHSNCodeChange = (event) => {
        if(event.target.value?.length > 0){
            let relatedGSTRates = HSNMasterData?.filter(eachHSN => eachHSN?.HSNCode === parseInt(event.target.value))
            if(relatedGSTRates && relatedGSTRates.length > 0){
                if(!relatedGSTRates.includes(event.target.value)){
                    return dispatch(raiseToast({severity:'warn', detail: `Change HSN or raise a tech team ticket`, life: 3000}))
                }
            }else{
                return dispatch(raiseToast({severity:'warn', detail: `Please enter valid HSNCode`, life: 3000}))
            }
        }
    }
    */


    const handleReplaceItemInputChange = (event) => {
        replaceItem[event.target.name] = event.target.value
        console.log("repalceItems", replaceItem)
        if(typeof (event.target.value) === "object"){
            replaceItem[event.target.name] = event.target.value
        }

        if (event.target.name === "HSNCode"){
            let relatedGSTRates = HSNMasterData?.filter(eachHSN => eachHSN?.HSNCode === parseInt(event.target.value))

            if(relatedGSTRates && relatedGSTRates.length > 0){
                let relatedReplaceItemGSTRate = relatedGSTRates.find(eachGSTRate => eachGSTRate.GSTRate === parseInt(replaceItem.GSTRate))
                if (!relatedReplaceItemGSTRate) {
                    return dispatch(raiseToast({ severity: 'warn', detail: `Change HSN or raise a tech team ticket`, life: 3000 }))
                }
            }
            /*
            if(relatedGSTRates && relatedGSTRates.length > 0){
                if(relatedGSTRates.length === 1){
                    replaceItem["GSTRate"] = relatedGSTRates[0].GSTRate
                }
                setGSTRates([...relatedGSTRates])
            }else{
                setGSTRates([])
            }
            */
        }

        if(replaceItem.qty){
            console.log("egwh")
            //let price = ((100/(100+replaceItem.GSTRate)) * replaceItem.totalAmount) / replaceItem.qty
            let price = replaceItem.totalAmount / replaceItem.qty
    
            replaceItem["unitPrice"] = round(price, DECIMAL_LIMIT)
        }
        
        setReplaceItem({...replaceItem})
    }

    const onClickReplaceItem = async() => {
        
        if (replaceItem.UOM && typeof (replaceItem.UOM) === 'object') {
            replaceItem["UOM"] = replaceItem.UOM.UOM
        } else {
            if(replaceItem.UOM){
                replaceItem["UOM"] = replaceItem.UOM
            }
            else{
                replaceItem["UOM"] = ''
            }
        }

        if (pmCompanyConfig.isInternational){
            replaceItem["HSNCode"] = pmCompanyConfig.defaultHSNCode
        }

        let validationResponse = await validateInputs(ReplacementItemValidationSchema, replaceItem)
        console.log("validationResponse===", validationResponse)

        if (validationResponse) {
            if (validationResponse.error) {
                setFormErrors(validationResponse.error)
            }
            else {
                if(validationResponse.result?.HSNCode?.length > 0){
                    let relatedGSTRates = HSNMasterData?.filter(eachHSN => eachHSN?.HSNCode === parseInt(validationResponse.result?.HSNCode))
        
                    if(relatedGSTRates && relatedGSTRates.length > 0){
                        if(relatedGSTRates && relatedGSTRates.length > 0){
                            let relatedReplaceItemGSTRate = relatedGSTRates.find(eachGSTRate => eachGSTRate.GSTRate === parseInt(replaceItem.GSTRate))
                            if (!relatedReplaceItemGSTRate) {
                                return dispatch(raiseToast({ severity: 'warn', detail: `Change HSN or raise a tech team ticket`, life: 3000 }))
                            }
                        }
                    }else{
                        return dispatch(raiseToast({severity:'warn', detail: `Please enter valid HSNCode`, life: 3000}))
                    }
                }
                setReplaceItem({ ...replaceItem, ...validationResponse.result })
                props.handleReplacementItem(validationResponse.result)
                setFormErrors({})
            }
        }

    }

    const searchUOMs = (event) => {
        const relatedUOMs = materialUOMData.filter(materialUOM => materialUOM.UOM.toLowerCase().includes(event.query.trim()?.toLowerCase()))
        setSearchedmaterialUOMs([...relatedUOMs])
    }

    const handleDragOver = (e) => {
        e.preventDefault();
    }

    const handleDrop = (e) => {
        e.preventDefault();
    }

    const isHSNEntryAllowed = pmCompanyConfig.HSNEntryAllowed

    return(
        <div className="">
            <div className="dispatch-note-list mb-3">
                <div className="custom-table-container">
                    <table className="custom-product-table" style={{ width: "100%" }}>
                        <thead >
                            <tr className="">
                                <th className="" style={{ width: "5%" }}>SR</th>
                                <th className="" style={{ width: "35%" }}>PRODUCT</th>
                                <th className="" style={{ width: "50%" }}>SPECIFICATION</th>
                                <th className="" style={{ width: "10%" }}>UOM</th>
                                <th className=""style={{ width: "10%" }} >UNIT PRICE</th>
                                <th className=""style={{ width: "10%" }} >QUANTITY</th>
                                <th className=""style={{ width: "10%" }} >{pmCompanyConfig.GSTRateLabel}</th>
                                <th className=""style={{ width: "10%" }} >TOTAL AMOUNT</th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                            {
                                selectedReplaceBuyerReqItems?.map((eachBuyerReqItem, index) => {
                                    let productName = eachBuyerReqItem?.companyProdName ? eachBuyerReqItem?.companyProdName : eachBuyerReqItem?.productName
                                    let productSpecification = eachBuyerReqItem?.companyProdSpec ? eachBuyerReqItem?.companyProdSpec : eachBuyerReqItem?.productSpecification                            
                                    return (
                                        <tr className="" key={`buyer-req-item-${eachBuyerReqItem?.buyerReqItemId}`} style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                            <td className="">{index + 1}</td>
                                            <td className="">{productName}</td>
                                            <td className="">{productSpecification}</td>
                                            <td className="">{eachBuyerReqItem?.UOM}</td>
                                            <td className="">{eachBuyerReqItem?.unitPrice}</td>
                                            <td className="">{eachBuyerReqItem?.qty}</td>
                                            <td className="">{eachBuyerReqItem?.GSTRate}</td>
                                            {/*<td className="custom-td">{round(eachBuyerReqItem?.unitPrice * eachBuyerReqItem?.qty,2)}</td>*/}
                                            <td className="">{round(eachBuyerReqItem.totalAmount,DECIMAL_LIMIT)}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            <p style={{fontWeight:"bold"}}>Replace Item Details</p>
            <div className="grid">
                <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                    <TextInputField name="companyProdName" labelText="Product Name" value={replaceItem.companyProdName} onChange={handleReplaceItemInputChange} errorMessage={formErrors.productName} required  />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                    <TextInputField name="companyProdSpec" labelText="Specification" value={replaceItem.companyProdSpec} onChange={handleReplaceItemInputChange} errorMessage={formErrors.productSpecification} required />
                </div>
                {
                    isHSNEntryAllowed ?
                    <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                        <TextInputField name="HSNCode" labelText="HSNCode" value={replaceItem.HSNCode} keyfilter={"pint"} onChange={handleReplaceItemInputChange} errorMessage={formErrors.HSNCode} required />
                    </div>
                    :
                    null
                }
                <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                    <TextInputField name="GSTRate" labelText={pmCompanyConfig.GSTRateLabel} value={replaceItem.GSTRate} onChange={handleReplaceItemInputChange} keyfilter="pnum" errorMessage={formErrors.GSTRate} required disabled />
                </div>
                {/*
                <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                    <DropDownField 
                        name="GSTRate" 
                        labelText='GSTRate' 
                        value={replaceItem.GSTRate} 
                        options={GSTRates} 
                        optionLabel="GSTRate" 
                        optionValue="GSTRate" 
                        keyfilter="pnum" 
                        onChange={handleReplaceItemInputChange} 
                        required 
                        errorMessage={formErrors.GSTRate}
                        //disabled
                    />
                </div>
                */}
                <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                    <TextInputField name="qty" labelText="Quantity" value={replaceItem.qty} keyfilter={"pnum"} onChange={handleReplaceItemInputChange} errorMessage={formErrors.qty} required />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                    <AutoCompleteField name="UOM" labelText="UOM" field="UOM" placeholder="UOM" value={replaceItem.UOM} suggestions={searchedmaterialUOMs} searchMethod={searchUOMs} onChange={(e) => handleReplaceItemInputChange(e)} onDragOver={handleDragOver} onDrop={handleDrop} dropdown forceSelection errorMessage={formErrors.UOM} required />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                    <TextInputField name="unitPrice" labelText="Unit Price" value={replaceItem.unitPrice} onChange={handleReplaceItemInputChange} required disabled errorMessage={formErrors.unitPrice} />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                    <TextInputField name="totalAmount" labelText="Total Amount" value={replaceItem.totalAmount} onChange={handleReplaceItemInputChange} required disabled errorMessage={formErrors.totalAmount} />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                    <TextInputField name="totalAmountWithTax" labelText="Total Amount With Tax" value={replaceItem.totalAmountWithTax} onChange={handleReplaceItemInputChange} required disabled errorMessage={formErrors.totalAmountWithTax} />
                </div>
            </div>
            <div className='mt-3 flex justify-content-end'>
                <Button className="small-btn" label="Replace" onClick={onClickReplaceItem} />
            </div>
            <Loading visible={isLoading} />
        </div>
    )
}

export default ReplacementItems